import React from 'react';
import imgResolver from '../../utils/img-resolver';
import Week from './Week';
import DayNames from './DayNames';
import moment from 'moment';
import 'moment-timezone';

class Calendar extends React.Component {

    sortShifts() {
        let colors = {
            'orange': [],
            'green': [],
            'gray': []
        };
        this.props.shifts.forEach(shift => {
            const end_time = moment(shift.end_time).tz(shift.company.timezone),
                isDraft = shift.status == "draft",
                isFull = shift.candidates_hired == shift.workers_needed,
                isFinished = shift.status == "finished",
                isCompleted = end_time < moment() || shift.status == 'ended',
                formattedDate = moment(shift.start_time).tz(shift.company.timezone).format('DD.MM.YYYY'),
                isCancelled = shift.status == "cancelled" || (shift.hiring && ['cancelled', 'cancelled by us'].indexOf(shift.hiring.status) >= 0);

            // Dot color
            if(isCompleted && !isFinished && !isCancelled && !isDraft) {
                colors['orange'].push(formattedDate);
            } else if (isDraft) {
                colors['gray'].push(formattedDate);
            } else if (isFull || isFinished || isCancelled) {
                colors['green'].push(formattedDate);
            }else {
                // if published
                colors['orange'].push(formattedDate);
            }
        });

        return colors;
    }

    render() {
        const renderBody = !this.props.headerOnly;
        const calendarBody = (
            <div className="calendar-body">
                <DayNames/>
                {this.renderWeeks()}
            </div>
        );

        let classes = "calendar left ";
        let onClick = this.props.iconClick;
        if (typeof this.props.className !== 'undefined') {
            classes += this.props.className;
        }
        if (!renderBody) {
            classes += 'calendar-centered';
            onClick = null;
        }

        return (
            <div className={classes}>
                <div className="calendar-header media">
                    <button className="calendar-arrow calendar-left left" onClick={this.props.prevMonth} />
                        <span className="calendar-header-month body">
                            {this.props.month.format("MMMM, YYYY")}
                            <img onClick={onClick}
                                 className="calendar-icon" src={require('../../styles/images/icon-calendar.svg')}
                                 alt="Gigpanel"/>
                        </span>
                    <button className="calendar-arrow calendar-right right" onClick={this.props.nextMonth} />
                </div>
                {renderBody ? calendarBody : null}
            </div>
        );
    }

    renderWeeks() {
        const weeks = [];
        let done = false;
        const DOW_MONDAY = 1;
        let date = this.props.month.clone().startOf("month").day(DOW_MONDAY);
        let monthIndex = date.month();
        let count = 0;

        while (!done) {
            weeks.push(
                <Week key={date.toString()}
                      date={date.clone()}
                      month={this.props.month}
                      select={this.props.select}
                      selected={this.props.selected}
                      coloredDates={this.sortShifts()}
                />
            );
            date.add(1, "w");
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }

        return weeks;
    }
}
export default Calendar;



/** WEBPACK FOOTER **
 ** ./app/src/components/Calendar/Calendar.js
 **/